import React from 'react';
import { LightbulbIcon, CheckCircleIcon } from 'lucide-react';
export const Solution = () => {
  return <section className="mb-10" data-id="element-126">
      <div className="bg-blue-50 p-5 rounded-lg mb-8 border-l-4 border-blue-500" data-id="element-127">
        <h2 className="text-xl font-bold text-blue-800 flex items-center mb-4" data-id="element-128">
          <LightbulbIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-129" />
          De Schokkende Ontdekking Die Alles Verandert
        </h2>
        <p className="mb-4 leading-relaxed" data-id="element-130">
          Na jaren van onderzoek realiseerde ik me iets wat de hele hondenwereld
          op zijn kop zet:
        </p>
        <p className="text-lg font-semibold text-blue-800 mb-4" data-id="element-131">
          Je denkt dat je hond praat door te blaffen of te kwispelen, maar in
          werkelijkheid communiceert je hond de hele dag door met een complete
          taal van subtiele signalen.
        </p>
        <p className="leading-relaxed" data-id="element-132">
          Deze lichaamstaal is helemaal niet ingewikkeld - maar wij mensen
          spreken het van nature niet en moeten het dus eerst leren, net zoals
          je een nieuwe taal leert. Het is alsof je jarenlang in Frankrijk woont
          zonder Frans te spreken en je afvraagt waarom niemand je begrijpt.
        </p>
      </div>
      <div className="w-full mb-6" data-id="element-133">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mPezTbx7aSGaxHbt8eLB8F/Scherm%C2%ADafbeelding_2025-08-15_om_15.37.25.png" alt="Vrouw in oranje trui communiceert met haar border collie in een park" className="w-full h-auto rounded-lg shadow-md" data-id="element-134" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-135">
          Wanneer je de hondentaal spreekt, ontstaat er een diepere band en
          wederzijds begrip
        </p>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-136">
        Omdat je deze cruciale signalen niet kent, begrijpt je hond je niet en
        voelt hij zich niet begrepen. Deze miscommunicatie is de ware reden
        waarom jullie niet die diepere band hebben die mogelijk is.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-137">
        Laat me je een voorbeeld geven. Neem Marieke uit Amsterdam, die 12 jaar
        lang een Golden Retriever had. Na het volgen van mijn methode vertelde
        ze:{' '}
        <span className="italic" data-id="element-138">
          "Ik kijk nu ook echt anders naar mijn hond. Waar ik dacht vooral een
          angstige hond te hebben, blijkt zij gewoon heel beleefd te zijn. Mijn
          benadering naar haar toe is daardoor compleet anders."
        </span>
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-139">
        Wat Marieke dacht dat angst was, bleek respectvol gedrag te zijn. Haar
        hond probeerde al die tijd beleefd te communiceren, maar Marieke sprak
        de taal niet.
      </p>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-140">
        De Wetenschappelijke Basis
      </h2>
      <p className="mb-4 leading-relaxed" data-id="element-141">
        Dit is geen feelgood verhaal zonder basis. Mijn methode wordt
        ondersteund door 27 wetenschappelijke onderzoeken die allemaal hetzelfde
        aantonen:
      </p>
      <ul className="mb-6 space-y-3" data-id="element-142">
        <li className="flex items-start" data-id="element-143">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-144" />
          <span data-id="element-145">
            <strong data-id="element-146">Handgebaren zijn 99% effectief</strong> versus 82% bij
            stemcommando's. Honden begrijpen je gebaren van nature beter dan je
            woorden.
          </span>
        </li>
        <li className="flex items-start" data-id="element-147">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-148" />
          <span data-id="element-149">
            <strong data-id="element-150">Alfa-methoden hebben negatief effect:</strong> Onderzoek
            toont aan dat straffen, corrigeren en een dominante houding van de
            baas zorgt voor verhoogde stress levels bij je hond. Hierdoor wordt
            die juist banger, prikkelbaarder en onzekerder waardoor je juist
            meer probleemgedrag krijgt.
          </span>
        </li>
        <li className="flex items-start" data-id="element-151">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-152" />
          <span data-id="element-153">
            <strong data-id="element-154">Het oxytocine effect:</strong> Liefdevol contact verhoogt
            het 'knuffel-hormoon' bij zowel jou als je hond, wat de band
            versterkt.
          </span>
        </li>
      </ul>
      <p className="font-semibold text-blue-800" data-id="element-155">
        Deze wetenschap vormde de basis voor wat ik nu de 'Gids voor de
        Hondentaal' noem, en ik deel deze kennis in mijn GRATIS webinar.
      </p>
    </section>;
};